import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";

import { useRecoilState, useRecoilValue } from "recoil";
import { routeInfo, rowSelected } from "recoilState/GlobalState";

import { generateColumns } from "services/Local-services";

import { DataGridPro as DataGrid, esES, LicenseInfo } from "@mui/x-data-grid-pro";
// import { DataGrid } from "@mui/x-data-grid";

import classes from "./XGrid.module.scss";
import { LICENSE_KEY } from "consts/env";

LicenseInfo.setLicenseKey(LICENSE_KEY);

export default function XGridServer({
    titles,
    updateList = async () => { },
    onPageChange = () => { },
    onPageSizeChange = () => { },
    onNumberOfPagesChange = () => { },
    forceReset = false,
    forceUpload = false,
    loading,
    secondarySelected,
    setSecondarySelected,
    autoRow
}) {
    const [isLoading, setIsLoading] = useState(loading);
    const [rows, setRows] = useState([]);
    const [rowCount, setRowCount] = useState(0);
    const [page, setPage] = useState(0);
    const [pageSize, setPageSize] = useState(0);
    const [numberOfPages, setNumberOfPages] = useState(1);
    const [reset, setReset] = useState(false);
    const [upload, setUpload] = useState(false);
    const [loaded, setLoaded] = useState(false);

    const { route } = useRecoilValue(routeInfo);
    const [selected, setSelected] = useRecoilState(rowSelected);

    const { row } = secondarySelected ? secondarySelected : selected;
    const setter = setSecondarySelected ? setSecondarySelected : setSelected;

    const hasLoadedRef = useRef(false);

    const getList = useCallback(async (newPage = 0) => {
        setIsLoading(true);
        const { rows: newRows, rowCount: newRowCount } = await updateList(
            newPage,
            pageSize
        );

        setRows(newRows);
        setRowCount(newRowCount);
        setIsLoading(false);
    }, [pageSize, updateList]);

    useEffect(() => {
        if (pageSize === 0 || loading || hasLoadedRef.current) return;
        hasLoadedRef.current = true;
        getList();
    }, [pageSize, loading, getList]);

    useEffect(() => {
        setIsLoading(loading);
    }, [loading]);

    useEffect(() => {
        if (forceUpload !== upload) {
            getList(page);
            setUpload(forceUpload);
        }
        if (forceReset !== reset) {
            getList(0);
            setReset(forceReset);
        };
    }, [forceUpload, getList, page, upload, forceReset, reset, pageSize]);

    const columns = useMemo(() => generateColumns(titles, route), [titles, route]);

    return (
        <DataGrid

            columns={columns}
            rows={rows ?? []}
            rowCount={rowCount ?? 0}
            count={rowCount ?? 0}
            loading={isLoading}
            onRowClick={(data) => {
                if (data.row.id === row?.id) {
                    setter({ status: false, row: {} })
                    return;
                }
                setter({ status: true, row: data.row })
            }}
            selectionModel={row?.id || []}
            pagination
            page={page}
            // pageSize={pageSize}
            autoPageSize
            // localeText={esES.components.MuiDataGrid.defaultProps.localeText}
            getRowHeight={() => autoRow ??  null }
            sx={{
                '& .MuiDataGrid-row': {
                    minHeight: '36px !important', // El mínimo que vos quieras
                }
            }}
            paginationMode="server"
            onPageChange={(newPage) => {
                setPage(newPage);
                onPageChange(newPage);
                getList(newPage);
            }}
            onPageSizeChange={(newPageSize) => {
                setPageSize(newPageSize);
                onPageSizeChange(newPageSize);
            }}
            onStateChange={(state) => {
                const newNumberOfPages = state.pagination.pageCount + 1;
                if (newNumberOfPages !== numberOfPages) {
                    setNumberOfPages(newNumberOfPages);
                    onNumberOfPagesChange(newNumberOfPages);
                }
            }}
            className={classes.root}
            hideFooterSelectedRowCount
            disableMultipleSelection
            rowHeight={36}
            disableColumnMenu
            localeText={{
                noRowsLabel: 'Sin datos',
                noResultsOverlayLabel: 'No se encontraron resultados.',
                errorOverlayDefaultLabel: 'Ha ocurrido un error.',
                MuiTablePagination: {
                    labelRowsPerPage: 'Filas por página:',
                    labelDisplayedRows: ({ from, to, count }) => {
                        const total = count === -1 ? `más de ${to}` : count;
                        return `${from}-${to} de ${total}`;
                    },
                },
            }}
        />
    );
}
